/**
 * Teals Design System - Breakpoint Tokens
 *
 * Responsive design breakpoints for web applications.
 */
export const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};
// Media query helpers
export const mediaQueries = {
    xs: `@media (min-width: ${breakpoints.xs}px)`,
    sm: `@media (min-width: ${breakpoints.sm}px)`,
    md: `@media (min-width: ${breakpoints.md}px)`,
    lg: `@media (min-width: ${breakpoints.lg}px)`,
    xl: `@media (min-width: ${breakpoints.xl}px)`,
    xxl: `@media (min-width: ${breakpoints.xxl}px)`,
};
// Max-width media queries (for mobile-first overrides)
export const mediaQueriesMax = {
    xs: `@media (max-width: ${breakpoints.sm - 1}px)`,
    sm: `@media (max-width: ${breakpoints.md - 1}px)`,
    md: `@media (max-width: ${breakpoints.lg - 1}px)`,
    lg: `@media (max-width: ${breakpoints.xl - 1}px)`,
    xl: `@media (max-width: ${breakpoints.xxl - 1}px)`,
};
// Container max-widths for each breakpoint
export const containerMaxWidths = {
    sm: '540px',
    md: '720px',
    lg: '960px',
    xl: '1140px',
    xxl: '1320px',
};
